<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup add new company
 * @created at      :   2022/07/25
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import { mapMutations } from 'vuex';
import repository from '@/utils/repository';
import helpers from '@/utils/helpers';
// import store from '@/store';
import messages, { MSG_TYPE } from '@/utils/messages';
import _ from 'lodash';
import moment from 'moment';
/**
 * Import template
 */
import template from './template.html';
import './style.scss';

const initCompany = {
    p002: 0,
    p003: '',
    p004: '',
    p005: '',
    p006: '',
    p007: '1',
    p008: '0'
};
/**
 * Define component chat for show page chat
 */
var PopupAddNewCompany = {
    template: template,
    props: {
        modelValue: Boolean,
        onSelected: Function
    },
    emits: ['update:modelValue'],
    data() {
        return {
            listAttr: [],
            company: { ...initCompany },
            validRules: {
                p002: 'required',
                p003: 'required',
                p005: 'required',
                p006: 'required:katakana'
            }
        };
    },
    computed: {
        showModal: {
            get() {
                return this.modelValue;
            },
            set() {}
        }
    },
    methods: {
        ...mapMutations('app', ['showModalMessage', 'hideHeaderError']),
        close() {
            this.$emit('update:modelValue', false);
            this.hideHeaderError();
            this.company = { ...initCompany };
        },
        onShow() {
            this.initData();
            this.hideHeaderError();
        },
        initData() {
            repository.get(`/common/companies/data/init`).then((res) => {
                const { data } = res;
                if (data.Code === 200) {
                    this.listAttr = _.map(data.Data.登録属性, (item) => {
                        return {
                            code: item.コード,
                            name: item.名称
                        };
                    });
                } else {
                    this.listAttr = [];
                }
            });
        },
        saveData() {
            const vm = this;
            if (!helpers.isValidData(vm.company, vm.validRules)) {
                return;
            }
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                content: messages.C006,
                callback: (ok) => {
                    if (ok) {
                        repository
                            .post(`/common/companies`, vm.company)
                            .then((res) => {
                                const { data } = res;
                                if (
                                    data.Code === 200 &&
                                    data.Data &&
                                    data.Data.処理結果 == '0'
                                ) {
                                    this.showModalMessage({
                                        type: MSG_TYPE.SUCCESS,
                                        content: messages.S008,
                                        callback: (ok) => {
                                            if (ok) {
                                                if (this.onSelected) {
                                                    this.onSelected(vm.company);
                                                }
                                                this.close();
                                            }
                                        }
                                    });
                                }
                            });
                    }
                }
            });
        },
        setDateTo(date) {
            if (this.company.p002 != 2) {
                return;
            }
            this.company.p004 = moment(date, 'YYYY/MM/DD')
                .add(1, 'months')
                .add(-1, 'days')
                .format('YYYY/MM/DD');
        }
    }
};
export default PopupAddNewCompany;
</script>
